/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import {
    object, string, func, shape, number, bool,
} from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import withStyles from '@material-ui/core/styles/withStyles';
import Media from 'react-media';
import { main as MainStyle } from '../style/main';

import EventDispatcher from '../state/reducers/EventDispatcher';
import AccountHome from './MyAccount/AccountHome';
import AddressBook from './AddressBook/AddressBook';
import BillingAddress from './BillingAddress/BillingAddress';
import TrackOrder from './TrackOrder/TrackOrder';
import OrderDetails from './OrderDetails/OrderDetails';
import OrderDetailsByEmail from './OrderDetails/OrderDetailsByEmail';
import Subscriptions from './Subscriptions/Subscriptions';
import ProfileAndPassword from './ProfileAndPassword/ProfileAndPassword';
import ChangePassword from './ChangePassword/ChangePassword';
import ChangeEmail from './ChangeEmail/ChangeEmail';
import EmailPreference from './EmailPreference/EmailPreference';
import Passport from './Passport/Passport';
import UIModal from '../common/UIModal';
import CUSTOM_BREAKPOINTS from '../../../helpers/customBreakpoints';
import { getFeatureFlags } from '../utils/featureSelectors';
import getSiteConfig from '../utils/getSiteConfig';
import configENV from '../config';
import { isEmpty } from '../utils/object';
import GraphqlSeoHeadTags from '../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import OrderListing from './OrderListing/OrderListing';
import WishlistComponent from './Wishlist/Wishlist';
import OrderDetailsPLA from './OrderListing/OrderDetailsPLA';

const { PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => MainStyle(typography, palette);

const Components = {
    AccountHome,
    TrackOrder,
    OrderDetails,
    OrderDetailsByEmail,
    Subscriptions,
    AddressBook,
    BillingAddress,
    ProfileAndPassword,
    ChangePassword,
    ChangeEmail,
    EmailPreference,
    Passport,
    OrderListing,
    OrderDetailsPLA,
    WishlistComponent,
};

class MyAccount extends PureComponent {
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { fetchUserProfile } = this.props;
        fetchUserProfile();
    };

    render() {
        const {
            classes, module, userProfile, featureFlags, brandId,
        } = this.props;
        const seo = {
            page_title: 'My Account',
            meta_description: '',
            location: { pathname: '/account/orders' },
        };
        const Layout = Components[module];
        const isWhislist = module === 'WishlistComponent';
        const breakpointExpr = `(min-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
        if (isEmpty(userProfile) || !brandId) return null;
        return (
            <>
                <GraphqlSeoHeadTags seoData={seo} />
                <Media query={breakpointExpr}>
                    {(matches) => (
                        matches ? (
                            <div className={isWhislist ? '' : `${classes.main} desktop ${brandId}`}>
                                <Layout userProfile={userProfile} featureFlags={featureFlags} />
                            </div>
                        ) : (
                            <div className={`${classes.main}`}>
                                <Layout userProfile={userProfile} featureFlags={featureFlags} />
                            </div>
                        ))}
                </Media>

                <UIModal />
            </>
        );
    }
}

MyAccount.defaultProps = {
    userProfile: {},
    featureFlags: {},
};

MyAccount.propTypes = {
    classes: object.isRequired,
    module: string.isRequired,
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }),
    featureFlags: object,
    brandId: string.isRequired,
    fetchUserProfile: func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    let featureFlags = {};
    const brandId = getSiteConfig('brand-id') || '';
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
            // eslint-disable-next-line no-empty
        } catch (ex) {}
    }
    return {
        userProfile: newState.userProfile,
        featureFlags,
        brandId,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchUserProfile: () => dispatch(EventDispatcher.fetchUserProfile()),
});

const enhance = compose(
    withPageView({
        pageViewSuccessTest: () => true,
    }),
    withRouter,
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(MyAccount);
